import DuoToneTextDefault from './DuoToneTextDefault';
import { DuoToneTextDefaultProps, DuoToneTextDefaultValueProps } from './types';

export type { DuoToneTextDefaultProps, DuoToneTextDefaultValueProps };
export default DuoToneTextDefault;
